function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import "jquery.cookie";
import * as React from "react";
import * as ReactDOM from "react-dom";
import * as Api from "../ajax/SessionHistoryApi";
import * as Utility from "../commons/Utility";
import moment from 'moment';
import IntlMessage from '../commons/Intl';
import { Label, SessionHistories, Action, Capture } from '../commons/IntlMessages';
import ReactDatePicker from "react-datepicker";
import CustomHistorySearchDateComponent from "./CustomHistorySearchDateComponent";
import * as SessionHistoryEditMemoModalComponent from "./SessionHistoryEditMemoModalComponent";
var defaultLanguage = 'ja';
var intl = new IntlMessage(defaultLanguage);
var language = window.navigator.language.substring(0, 2) === 'ja' ? 'ja' : 'en';
intl.setLanguage(language);
/**
 * メインコンポーネント
 */

var MainComponent = /*#__PURE__*/function (_React$Component) {
  _inherits(MainComponent, _React$Component);

  var _super = _createSuper(MainComponent);

  /**
   * フィールド変数の初期化を行います。
   *
   * @param props プロップス
   */
  function MainComponent(props) {
    var _this;

    _classCallCheck(this, MainComponent);

    _this = _super.call(this, props);
    var now = moment();
    var searchStart = now.clone().add('month', -1);
    _this.state = {
      QueryIntervalId: 0,
      SearchStartDate: searchStart,
      SearchEndDate: null,
      SearchWord: "",
      SearchConditionAreaHeight: 0,
      ListAreaHeight: 0,
      CaptureColWidth: 0,
      SessionHistorySessionList: null,
      SelectedSessionHistoryIndex: null,
      SelectedSessionHistoryItem: null,
      SelectedSession: null,
      IsThumbnailModalOpen: false,
      IsCaptureModalOpen: false,
      EditMemModalMode: SessionHistoryEditMemoModalComponent.Mode.None,
      EditSessionIndex: null,
      EditMaterialIndex: null,
      EditMemoIndex: null,
      EditMemo: null
    };

    if (_this.props.sessionId < 0) {
      _this.onSearch(false, null);
    } else {
      _this.onSearch(false, _this.props.sessionId);
    }

    return _this;
  }
  /**
   * 検索結果をクリア後、検索を行います。
   */


  _createClass(MainComponent, [{
    key: "onSearchWithClear",
    value: function onSearchWithClear() {
      var _this2 = this;

      this.setState({
        SessionHistorySessionList: null
      }, function () {
        _this2.onSearch(false, null);
      });
    }
    /**
     * 検索を行います。
     */

  }, {
    key: "onSearch",
    value: function onSearch(isAsync, sessionId) {
      var _this3 = this;

      var startDate;

      if (this.state.SearchStartDate == null) {
        startDate = null;
      } else {
        startDate = Utility.parseMoment(this.state.SearchStartDate, 0, 0);
      }

      var endDate;

      if (this.state.SearchEndDate == null) {
        endDate = null;
      } else {
        endDate = Utility.parseMoment(this.state.SearchEndDate, 0, 0);
      }

      Api.Query(sessionId, sessionId ? null : startDate, sessionId ? null : endDate, this.state.SearchWord, isAsync, function (data) {
        if (_this3.state.SelectedSession == null) {
          _this3.setState({
            SessionHistorySessionList: data.SessionHistorySessionList
          }, function () {
            setTimeout(function () {
              $("#overlay").fadeOut(300);
            }, 500);
          });
        } else {
          var sessionId = _this3.state.SelectedSession.SessionId;
          var selectedSessionIndex = data.SessionHistorySessionList.findIndex(function (s) {
            return s.SessionId == sessionId;
          });
          var selectedSession = data.SessionHistorySessionList[selectedSessionIndex];

          _this3.setState({
            SessionHistorySessionList: data.SessionHistorySessionList,
            SelectedSession: selectedSession
          }, function () {
            if (_this3.state.SessionHistorySessionList) {
              var count = selectedSession.SessionHistoryCaptureList.length <= 3 ? selectedSession.SessionHistoryCaptureList.length : 3;

              for (var j = 0; j < count; j++) {
                var loading = $(".loadingImage-" + selectedSessionIndex.toString() + "-" + j.toString());
                var capture = $(".photoImage-" + selectedSessionIndex.toString() + "-" + j.toString());
                var captureImage = selectedSession.SessionHistoryCaptureList[j];

                if (loading && capture) {
                  if (capture.hasClass("loading-hidden")) {
                    if (captureImage) {
                      Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, selectedSessionIndex, j, function (x, y, file) {
                        var loading = $(".loadingImage-" + x.toString() + "-" + y.toString());
                        var capture = $(".photoImage-" + x.toString() + "-" + y.toString());
                        capture.attr('src', URL.createObjectURL(file));
                        loading.addClass("loading-hidden");
                        capture.removeClass("loading-hidden");
                      });
                    } else {
                      capture.attr('src', "/assets/img/noimage.png");
                      loading.addClass("loading-hidden");
                      capture.removeClass("loading-hidden");
                    }
                  }
                }
              }

              for (var i = 0; i < selectedSession.SessionHistoryCaptureList.length; i++) {
                var loading = $(".loadingImage-" + i.toString());
                var capture = $(".photoImage-" + i.toString());
                var captureImage = selectedSession.SessionHistoryCaptureList[i];

                if (loading && capture) {
                  if (capture.hasClass("loading-hidden")) {
                    if (captureImage) {
                      Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, i, 0, function (x, y, file) {
                        var loading = $(".loadingImage-" + x.toString());
                        var capture = $(".photoImage-" + x.toString());
                        capture.attr('src', URL.createObjectURL(file));
                        loading.addClass("loading-hidden");
                        capture.removeClass("loading-hidden");
                      });
                    } else {
                      capture.attr('src', "/assets/img/noimage.png");
                      loading.addClass("loading-hidden");
                      capture.removeClass("loading-hidden");
                    }
                  }
                }
              }
            }

            setTimeout(function () {
              $("#overlay").fadeOut(300);
            }, 500);
          });
        }
      });
    }
    /**
     * クリアを行います。
     */

  }, {
    key: "onClear",
    value: function onClear() {
      var _this4 = this;

      this.setState({
        SearchStartDate: null,
        SearchEndDate: null,
        SearchWord: "",
        SessionHistorySessionList: null,
        SelectedSessionHistoryIndex: null,
        SelectedSessionHistoryItem: null,
        SelectedSession: null,
        QueryIntervalId: window.setInterval(this.onSearch.bind(this, true), this.props.queryRefreshInterval)
      }, function () {
        _this4.onSearch(false, null);
      });
    }
    /**
     * 検索ワードを更新します。
     *
     * @param e イベント
     */

  }, {
    key: "updateSearchWord",
    value: function updateSearchWord(e) {
      this.setState({
        SearchWord: e.target.value.substring(0, e.target.maxLength)
      });
    }
    /**
     * 検索：開始日を更新します。
     *
     * @param d 開始日
     */

  }, {
    key: "updateSearchStartDate",
    value: function updateSearchStartDate(d) {
      this.setState({
        SearchStartDate: d
      });
    }
    /**
     * 検索：終了日を更新します。
     *
     * @param d 終了日
     */

  }, {
    key: "updateSearchEndDate",
    value: function updateSearchEndDate(d) {
      this.setState({
        SearchEndDate: d
      });
    }
    /**
     * 会議情報を展開します。
     */

  }, {
    key: "onView",
    value: function onView(m, i) {
      var target = document.querySelectorAll('.historyListItem__cont')[i];
      var targetBtn = document.querySelectorAll('.historyListItem__toggleBtn')[i];
      target.classList.toggle('historyListItem__cont--hide');
      targetBtn.classList.toggle('historyListItem__toggleBtn--open');

      if (this.state.SessionHistorySessionList) {
        var selectedSession = this.state.SessionHistorySessionList[i];
        var count = selectedSession.SessionHistoryCaptureList.length <= 3 ? selectedSession.SessionHistoryCaptureList.length : 3;

        for (var j = 0; j < count; j++) {
          var loading = $(".loadingImage-" + i.toString() + "-" + j.toString());
          var capture = $(".photoImage-" + i.toString() + "-" + j.toString());
          var captureImage = selectedSession.SessionHistoryCaptureList[j];

          if (loading && capture) {
            if (capture.hasClass("loading-hidden")) {
              if (captureImage) {
                Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, i, j, function (x, y, file) {
                  var loading = $(".loadingImage-" + i.toString() + "-" + y.toString());
                  var capture = $(".photoImage-" + x.toString() + "-" + y.toString());
                  capture.attr('src', URL.createObjectURL(file));
                  loading.addClass("loading-hidden");
                  capture.removeClass("loading-hidden");
                });
              } else {
                capture.attr('src', "/assets/img/noimage.png");
                loading.addClass("loading-hidden");
                capture.removeClass("loading-hidden");
              }
            }
          }
        }
      }
    }
    /**
     * キャプチャモーダル用に選択された会議開催履歴をセットします。
     */

  }, {
    key: "setSelectedHistoryItem",
    value: function setSelectedHistoryItem(m, i, c) {
      this.setState({
        IsCaptureModalOpen: true,
        SelectedSession: m,
        SelectedSessionHistoryIndex: i,
        SelectedSessionHistoryItem: c
      }, function () {
        var loading = $("#CaptureModelLoading");
        var capture = $("#CaptureModalCapture");
        var captureImage = m.SessionHistoryCaptureList[i];

        if (loading && capture) {
          if (loading.hasClass("loading-hidden")) {
            loading.removeClass("loading-hidden");
            capture.addClass("loading-hidden");
          }

          if (captureImage) {
            Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, 0, 0, function (x, y, file) {
              var loading = $("#CaptureModelLoading");
              var capture = $("#CaptureModalCapture");
              capture.attr('src', URL.createObjectURL(file));
              loading.addClass("loading-hidden");
              capture.removeClass("loading-hidden");
            });
          } else {
            capture.attr('src', "/assets/img/noimage.png");
            loading.addClass("loading-hidden");
            capture.removeClass("loading-hidden");
          }
        }
      });
    }
    /**
     * サムネイルモーダル用に選択された会議をセットします。
     */

  }, {
    key: "setSelectedSession",
    value: function setSelectedSession(m) {
      this.setState({
        IsThumbnailModalOpen: true,
        SelectedSession: m
      }, function () {
        for (var i = 0; i < m.SessionHistoryCaptureList.length; i++) {
          var loading = $(".loadingImage-" + i.toString());
          var capture = $(".photoImage-" + i.toString());
          var captureImage = m.SessionHistoryCaptureList[i];

          if (loading && capture) {
            if (capture.hasClass("loading-hidden")) {
              if (captureImage) {
                Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, i, 0, function (x, y, file) {
                  var loading = $(".loadingImage-" + x.toString());
                  var capture = $(".photoImage-" + x.toString());
                  capture.attr('src', URL.createObjectURL(file));
                  loading.addClass("loading-hidden");
                  capture.removeClass("loading-hidden");
                });
              } else {
                capture.attr('src', "/assets/img/noimage.png");
                loading.addClass("loading-hidden");
                capture.removeClass("loading-hidden");
              }
            }
          }
        }
      });
    }
    /**
     * メモ編集モーダルを追加で起動します。
     */

  }, {
    key: "openEditMemoModal",
    value: function openEditMemoModal(indx, indy, indz, memo) {
      this.setState({
        EditMemModalMode: SessionHistoryEditMemoModalComponent.Mode.Edit,
        EditSessionIndex: indx,
        EditMaterialIndex: indy,
        EditMemoIndex: indz,
        EditMemo: memo
      });
    }
    /**
     * メモを更新します。
     *
     * @param sessionIndex 会議インデックス
     * @param materialIndex 素材インデックス
     * @param memoIndex メモインデックス
     * @param memo メモ
     * @param closeEvent 終了処理
     */

  }, {
    key: "editMemoModal",
    value: function editMemoModal(sessionIndex, materialIndex, memoIndex, memo, closeEvent) {
      var _this5 = this;

      var sessions = this.state.SessionHistorySessionList;

      if (sessions != null) {
        sessions[sessionIndex].SessionHistoryMaterialList[materialIndex].MemoList[memoIndex].Memo = memo;
        var sessionId = sessions[sessionIndex].SessionId;
        var entryDateTime = sessions[sessionIndex].SessionHistoryMaterialList[materialIndex].MemoList[memoIndex].MemoDateTime;
        Api.EditMemo(sessionId, entryDateTime, memo, function (data) {
          _this5.setState({
            SessionHistorySessionList: sessions
          }, function () {
            closeEvent();
          });
        });
      }
    }
    /**
     * メモ編集モーダルが完全に非表示になった際の処理を行います。
     */

  }, {
    key: "hiddenEditMemoModal",
    value: function hiddenEditMemoModal() {
      this.setState({
        EditMemModalMode: SessionHistoryEditMemoModalComponent.Mode.None,
        EditSessionIndex: null,
        EditMaterialIndex: null,
        EditMemoIndex: null,
        EditMemo: null
      });
    }
    /**
     * セッションの表示を行います。
     */

  }, {
    key: "viewSession",
    value: function viewSession(m) {
      $("#Action").val("ViewSession");
      $("#SessionId").val(m.SessionId);
      $("#MainForm").submit();
    }
    /**
     * レポートダウンロード処理を行います。
     *
     * @param selected 選択モデル
     */

  }, {
    key: "downloadReport",
    value: function downloadReport(m) {
      $("#Action").val("DownloadReport");
      $("#SessionId").val(m.SessionId);
      $("#MainForm").submit();
    }
    /**
     * キャプチャを削除します。
     *
     */

  }, {
    key: "onClickCaptureDelete",
    value: function onClickCaptureDelete(m, i, c) {
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.DeleteCapture(c.SessionId, c.SessionHistoryId, function (data) {
        $('#CaptureModal').modal('hide');
      });
    }
    /**
     * キャプチャをシーンのサムネイルに設定します。
     *
     */

  }, {
    key: "onClickSetSceneThumbnail",
    value: function onClickSetSceneThumbnail(m, i, c) {
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.SetSceneThumbnail(c.SessionId, c.SessionHistoryId, function (data) {
        $('#CaptureModal').modal('hide');
      });
    }
    /**
     * キャプチャをシーンのサムネイルから設定解除します。
     *
     */

  }, {
    key: "onClickClearSceneThumbnail",
    value: function onClickClearSceneThumbnail(m, i, c) {
      setTimeout(function () {
        $("#overlay").fadeIn();
      });
      Api.ClearSceneThumbnail(c.SessionId, c.SessionHistoryId, function (data) {
        $('#CaptureModal').modal('hide');
      });
    }
    /**
     * 前のキャプチャを表示します。
     *
     */

  }, {
    key: "onClickCaptureBack",
    value: function onClickCaptureBack(m, i, c) {
      var index = i;
      index = index - 1;

      if (index < 0) {
        index = m.SessionHistoryCaptureList.length - 1;
      }

      this.setState({
        SelectedSession: m,
        SelectedSessionHistoryIndex: index,
        SelectedSessionHistoryItem: m.SessionHistoryCaptureList[index]
      }, function () {
        var loading = $("#CaptureModalLoading");
        var capture = $("#CaptureModalCapture");
        var captureImage = m.SessionHistoryCaptureList[index];

        if (loading && capture) {
          if (loading.hasClass("loading-hidden")) {
            loading.removeClass("loading-hidden");
            capture.addClass("loading-hidden");
          }

          if (captureImage) {
            Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, 0, 0, function (x, y, file) {
              var loading = $("#CaptureModalLoading");
              var capture = $("#CaptureModalCapture");
              capture.attr('src', URL.createObjectURL(file));
              loading.addClass("loading-hidden");
              capture.removeClass("loading-hidden");
            });
          } else {
            capture.attr('src', "/assets/img/noimage.png");
            loading.addClass("loading-hidden");
            capture.removeClass("loading-hidden");
          }
        }
      });
    }
    /**
     * 次のキャプチャを表示します。
     *
     */

  }, {
    key: "onClickCaptureNext",
    value: function onClickCaptureNext(m, i, c) {
      var index = i;
      index = index + 1;

      if (m.SessionHistoryCaptureList.length <= index) {
        index = 0;
      }

      this.setState({
        SelectedSession: m,
        SelectedSessionHistoryIndex: index,
        SelectedSessionHistoryItem: m.SessionHistoryCaptureList[index]
      }, function () {
        var loading = $("#CaptureModalLoading");
        var capture = $("#CaptureModalCapture");
        var captureImage = m.SessionHistoryCaptureList[index];

        if (loading && capture) {
          if (loading.hasClass("loading-hidden")) {
            loading.removeClass("loading-hidden");
            capture.addClass("loading-hidden");
          }

          if (captureImage) {
            Api.GetCapture(captureImage.SessionId, captureImage.CaptureFileName, 0, 0, function (x, y, file) {
              var loading = $("#CaptureModalLoading");
              var capture = $("#CaptureModalCapture");
              capture.attr('src', URL.createObjectURL(file));
              loading.addClass("loading-hidden");
              capture.removeClass("loading-hidden");
            });
          } else {
            capture.attr('src', "/assets/img/noimage.png");
            loading.addClass("loading-hidden");
            capture.removeClass("loading-hidden");
          }
        }
      });
    }
    /**
     * ComponentがDOMツリーに追加された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this6 = this;

      this.props.common.bind();
      var captureModal = $('#CaptureModal');
      captureModal.on("hidden.bs.modal", function () {
        _this6.setState({
          IsCaptureModalOpen: false,
          SelectedSessionHistoryIndex: null,
          SelectedSessionHistoryItem: null
        });

        _this6.onSearch(false, null);
      });
      var thumbnailModal = $('#ThumbnailModal');
      thumbnailModal.on("hidden.bs.modal", function () {
        _this6.setState({
          IsThumbnailModalOpen: false,
          SelectedSession: null
        });

        _this6.onSearch(false, null);
      });
    }
    /**
     * ComponentがDOMツリーから削除された状態で呼ばれるDOMに関わる初期化処理
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.state.QueryIntervalId != null) {
        clearInterval(this.state.QueryIntervalId);
      }
    }
    /**
     * レンダラー
     */

  }, {
    key: "render",
    value: function render() {
      var _this7 = this,
          _this$state$SelectedS,
          _this$state$SelectedS2,
          _this$state$SelectedS3;

      return /*#__PURE__*/React.createElement("div", {
        className: "content-container"
      }, /*#__PURE__*/React.createElement("div", {
        id: "overlay"
      }, /*#__PURE__*/React.createElement("div", {
        className: "cv-spinner"
      }, /*#__PURE__*/React.createElement("span", {
        className: "spinner"
      }))), /*#__PURE__*/React.createElement("main", {
        className: "main newdesign"
      }, /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "Action",
        id: "Action",
        value: "ViewSession"
      }), /*#__PURE__*/React.createElement("input", {
        type: "hidden",
        name: "SessionId",
        id: "SessionId",
        value: ""
      }), /*#__PURE__*/React.createElement("div", {
        className: "main__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu",
        id: "menuCont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__title"
      }, intl.format(SessionHistories.Title)), /*#__PURE__*/React.createElement("div", {
        className: "menu__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyword"
      }, /*#__PURE__*/React.createElement("div", {
        className: "keyword__title"
      }, intl.format(SessionHistories.Keyword)), /*#__PURE__*/React.createElement("input", {
        type: "text",
        className: "keyword__input",
        maxLength: 100,
        onChange: function onChange(e) {
          return _this7.updateSearchWord(e);
        },
        value: this.state.SearchWord,
        placeholder: intl.format(SessionHistories.SearchWord)
      })), /*#__PURE__*/React.createElement("div", {
        className: "time"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time__title"
      }, intl.format(SessionHistories.TimeAndDate)), /*#__PURE__*/React.createElement("div", {
        className: "time__cont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time__contTitle"
      }, intl.format(Label.StartDate)), /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomHistorySearchDateComponent, null),
        name: "SearchStartDate",
        id: "SearchStartDate",
        selected: this.state.SearchStartDate,
        onChange: this.updateSearchStartDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      })), /*#__PURE__*/React.createElement("div", {
        className: "time__cont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "time__contTitle"
      }, intl.format(Label.EndDate)), /*#__PURE__*/React.createElement(ReactDatePicker, {
        customInput: /*#__PURE__*/React.createElement(CustomHistorySearchDateComponent, null),
        name: "SearchEndDate",
        id: "SearchEndDate",
        selected: this.state.SearchEndDate,
        onChange: this.updateSearchEndDate.bind(this),
        dateFormat: "YYYY/M/D",
        locale: "ja",
        showMonthDropdown: true,
        showYearDropdown: true,
        dropdownMode: "select"
      }))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn imgAndTextBtn",
        onClick: this.onSearchWithClear.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Search.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.ConditionSearch))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "menu__btn menu__btn--white imgAndTextBtn",
        onClick: this.onClear.bind(this)
      }, /*#__PURE__*/React.createElement("div", {
        className: "menu__btnImg imgAndTextBtn__btnImg"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Cancel.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(Action.Clear))))), /*#__PURE__*/React.createElement("div", {
        className: "mainContent"
      }, /*#__PURE__*/React.createElement("ul", {
        className: "mainContent__list"
      }, !this.state.SessionHistorySessionList && /*#__PURE__*/React.createElement("div", {
        className: "historyListItem__searchingHistory"
      }, /*#__PURE__*/React.createElement("div", {
        className: "historyListItem__searchingHistoryMessage"
      }, intl.format(SessionHistories.SearchingHistory))), this.state.SessionHistorySessionList && this.state.SessionHistorySessionList.length == 0 && /*#__PURE__*/React.createElement("div", {
        className: "historyListItem__noHistory"
      }, /*#__PURE__*/React.createElement("div", {
        className: "historyListItem__noHistoryMessage"
      }, intl.format(SessionHistories.NoHistory))), this.state.SessionHistorySessionList && this.state.SessionHistorySessionList.length > 0 && this.state.SessionHistorySessionList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("li", {
          className: "historyListItem"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__header"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContWrapper",
          onClick: _this7.onView.bind(_this7, x, _i)
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "historyListItem__toggleBtn"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__toggleBtnIcon"
        })), /*#__PURE__*/React.createElement("div", {
          className: "mainContentHeader__titleImg mainContentHeader__contImg mainContentHeader__contImg--title"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/Icon_Calender.svg"
        })), /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerCont"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContText"
        }, /*#__PURE__*/React.createElement("div", {
          title: x.SessionName,
          className: "historyListItem__headerContTextFirst historyListItem__headerContSessionName"
        }, x.SessionName), !Utility.IsSpecifyPeriodDate(x.EndDateTime) && /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContTextSecond"
        }, /*#__PURE__*/React.createElement("span", {
          className: "historyListItem__headerContSessionDate"
        }, Utility.ToMoment(x.StartDateTime).format("YYYY/MM/DD HH:mm"), " ~ ", intl.format(Label.IndefiniteDuration)), "\u3000", /*#__PURE__*/React.createElement("span", {
          className: "historyListItem__headerContSessionOthers"
        }, intl.format(Label.LastSaveDate), ":", x.LastSaveDateTime != null ? Utility.ToMoment(x.LastSaveDateTime).format("YYYY/MM/DD HH:mm") : "-")), Utility.IsSpecifyPeriodDate(x.EndDateTime) && /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContTextSecond"
        }, /*#__PURE__*/React.createElement("span", {
          className: "historyListItem__headerContSessionDate"
        }, Utility.ToMoment(x.StartDateTime).format("YYYY/MM/DD HH:mm"), " ~ ", Utility.ToMoment(x.EndDateTime).format("YYYY/MM/DD HH:mm")), "\u3000", /*#__PURE__*/React.createElement("span", {
          className: "historyListItem__headerContSessionOthers"
        }, intl.format(Label.LastSaveDate), ":", x.LastSaveDateTime != null ? Utility.ToMoment(x.LastSaveDateTime).format("YYYY/MM/DD HH:mm") : "-"))))), /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContWrapper"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerCont historyListItem__headerCont--member"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContImg historyListItem__headerContImg--member"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/Icon_Member.svg"
        })), /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContText"
        }, /*#__PURE__*/React.createElement("div", {
          title: intl.format(SessionHistories.Organizer, {
            name: x.OwnerName
          }),
          className: "historyListItem__headerContTextFirst"
        }, intl.format(SessionHistories.Organizer, {
          name: x.OwnerName
        })), /*#__PURE__*/React.createElement("div", {
          title: intl.format(SessionHistories.Paticipant, {
            name: x.Member
          }),
          className: "historyListItem__headerContTextSecond"
        }, intl.format(SessionHistories.Paticipant, {
          name: x.Member
        })))), /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__headerContBtnWrapper"
        }, /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "historyListItem__headerContBtn historyListItem__headerContBtn--dl imgAndTextBtn",
          onClick: _this7.downloadReport.bind(_this7, x)
        }, /*#__PURE__*/React.createElement("div", {
          className: "imgAndTextBtn__btnImg"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/Icon_Download.svg"
        })), /*#__PURE__*/React.createElement("div", {
          className: "imgAndTextBtn__btnText"
        }, intl.format(SessionHistories.DownloadReport))), /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "historyListItem__headerContBtn imgAndTextBtn historyListItem__headerContBtn--more",
          onClick: _this7.viewSession.bind(_this7, x)
        }, /*#__PURE__*/React.createElement("div", {
          className: "imgAndTextBtn__btnImg"
        }, /*#__PURE__*/React.createElement("img", {
          src: "/assets/img/Icon_Other.svg"
        })), /*#__PURE__*/React.createElement("div", {
          className: "imgAndTextBtn__btnText"
        }, intl.format(SessionHistories.DetailView)))))), /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__cont historyListItem__cont--hide"
        }, x.CaptureItemCount == 0 && x.MaterialItemCount == 0 && /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__contNoItemText"
        }, intl.format(SessionHistories.CaptureMemoNotFound)), x.CaptureItemCount > 0 && /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__contImgBox"
        }, /*#__PURE__*/React.createElement("div", {
          className: "historyListItem__contImgWrapper"
        }, x.SessionHistoryCaptureList.filter(function (_y, j) {
          return j < 3;
        }).map(function (y, j) {
          return /*#__PURE__*/React.createElement("a", {
            className: "button citem" + Utility.NullNumberToBlank(j),
            href: "#",
            key: y.SessionHistoryId,
            onClick: _this7.setSelectedHistoryItem.bind(_this7, x, j, y),
            "data-toggle": "modal",
            "data-target": "#CaptureModal",
            tabIndex: -1,
            title: y.CaptureFileNameWithoutExtension
          }, /*#__PURE__*/React.createElement("div", {
            className: "historyListItem__contImg"
          }, /*#__PURE__*/React.createElement("img", {
            className: "loadingImage-" + _i.toString() + "-" + j.toString() + " loading-spinner",
            src: "/assets/img/Loading.svg"
          }), /*#__PURE__*/React.createElement("img", {
            className: "photoImage-" + _i.toString() + "-" + j.toString() + " loading-hidden",
            src: "/assets/img/noimage.png"
          })));
        })), x.CaptureItemCount > 3 && /*#__PURE__*/React.createElement("button", {
          type: "button",
          className: "historyListItem__contImgBtn",
          onClick: _this7.setSelectedSession.bind(_this7, x),
          "data-toggle": "modal",
          "data-target": "#ThumbnailModal",
          tabIndex: -1,
          title: ""
        }, /*#__PURE__*/React.createElement("div", null, intl.format(SessionHistories.MoreCaptures, {
          number: x.CaptureItemCount - 3
        })))), x.MaterialItemCount > 0 && x.SessionHistoryMaterialList.map(function (y, j) {
          return /*#__PURE__*/React.createElement("div", {
            className: "historyListItem__contFileBox"
          }, /*#__PURE__*/React.createElement("div", {
            className: "historyListItem__contFile" + (y.MaterialFileName != null ? " historyListItem__contFile__shadows" : "")
          }, y.MaterialFileName != null && y.SessionHistoryId == null && y.RecordDateTime == null && /*#__PURE__*/React.createElement("div", {
            className: "historyListItem__contFileTitle"
          }, /*#__PURE__*/React.createElement("a", {
            href: "#",
            className: "session_link",
            onClick: _this7.viewSession.bind(_this7, x)
          }, y.MaterialFileName)), y.MaterialFileName != null && y.SessionHistoryId != null && y.RecordDateTime != null && /*#__PURE__*/React.createElement("div", {
            className: "historyListItem__contFileTitle"
          }, /*#__PURE__*/React.createElement("a", {
            className: "button citem" + Utility.NullNumberToBlank(x.SessionHistoryCaptureList.findIndex(function (c) {
              return c.SessionHistoryId == y.SessionHistoryId;
            })),
            href: "#",
            key: y.SessionHistoryId,
            onClick: _this7.setSelectedHistoryItem.bind(_this7, x, x.SessionHistoryCaptureList.findIndex(function (c) {
              return c.SessionHistoryId == y.SessionHistoryId;
            }), x.SessionHistoryCaptureList.find(function (c) {
              return c.SessionHistoryId == y.SessionHistoryId;
            })),
            "data-toggle": "modal",
            "data-target": "#CaptureModal",
            tabIndex: -1,
            title: y.MaterialFileNameWithoutExtention
          }, intl.format(SessionHistories.Recorder, {
            name: y.UserName
          }), " ", intl.format(SessionHistories.RecordingDate, {
            date: Utility.ToMoment(y.RecordDateTime).format("YYYY/MM/DD HH:mm")
          }))), /*#__PURE__*/React.createElement("div", {
            className: "historyListItem__contFileMain" + (y.MaterialFileName != null ? " historyListItem__contFileMain__shadows" : "")
          }, y.MemoList.map(function (z, k) {
            return /*#__PURE__*/React.createElement("div", {
              className: "commentBox"
            }, /*#__PURE__*/React.createElement("div", {
              className: "commentBox__color" + (z.MemoColor != null ? " commentBox__color" + z.MemoColor.toString() : "")
            }), /*#__PURE__*/React.createElement("div", {
              className: "commentBox__name"
            }, z.MemoUserName), /*#__PURE__*/React.createElement("div", {
              className: "commentBox__date"
            }, Utility.ToMoment(z.MemoDateTime).format("YYYY/MM/DD HH:mm")), /*#__PURE__*/React.createElement("div", {
              className: "commentBox__text" + (z.MemoFont != null ? " commentBox__text" + z.MemoFont.toString() : "")
            }, /*#__PURE__*/React.createElement("div", {
              className: "commentBox__backgroundcolor" + (z.MemoColor != null ? " commentBox__backgroundcolor" + z.MemoColor.toString() : "")
            }, /*#__PURE__*/React.createElement("div", {
              className: "commentBox__inlinetext"
            }, z.Memo != null ? z.Memo.split('\n').map(function (str, index) {
              return /*#__PURE__*/React.createElement(React.Fragment, {
                key: index
              }, str, /*#__PURE__*/React.createElement("br", null));
            }) : ""))), x.IsMyMeeting && /*#__PURE__*/React.createElement("button", {
              type: "button",
              className: "commentBox__btn",
              onClick: _this7.openEditMemoModal.bind(_this7, _i, j, k, z.Memo)
            }, /*#__PURE__*/React.createElement("div", {
              className: "commentBox__btnText"
            }, intl.format(Action.Modify))));
          }))));
        })));
      }))), /*#__PURE__*/React.createElement("div", {
        id: "modalArea"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal fade",
        id: "ThumbnailModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-dialog modal-lg",
        role: "document"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-content"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-header"
      }, /*#__PURE__*/React.createElement("div", {
        className: "modal-title"
      }, /*#__PURE__*/React.createElement("img", {
        className: "modalIcon",
        width: "48",
        height: "42",
        src: "/assets/img/minutes_icon.svg"
      }), /*#__PURE__*/React.createElement("h3", null, intl.format(Capture.Title))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))), /*#__PURE__*/React.createElement("div", {
        className: "modal-body"
      }, /*#__PURE__*/React.createElement("div", {
        id: "ThumbnailModalCaptures",
        className: "row offset-1 col-10"
      }, this.state.SelectedSession && this.state.SelectedSession.SessionHistoryCaptureList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "col-1-5",
          key: x.SessionHistoryId
        }, /*#__PURE__*/React.createElement("a", {
          className: "button",
          href: "#",
          key: x.SessionHistoryId,
          onClick: _this7.setSelectedHistoryItem.bind(_this7, _this7.state.SelectedSession, _i, x),
          "data-toggle": "modal",
          "data-target": "#CaptureModal",
          tabIndex: -1,
          title: "Capture" + x.SessionHistoryId
        }, /*#__PURE__*/React.createElement("img", {
          className: "photoImage loadingImage-" + _i.toString() + " loading-spinner",
          style: {
            marginRight: "1rem"
          },
          src: "/assets/img/Loading.svg"
        }), /*#__PURE__*/React.createElement("img", {
          className: "photoImage photoImage-" + _i.toString() + " loading-hidden",
          style: {
            marginRight: "1rem"
          },
          src: "/assets/img/noimage.png"
        })));
      })))))), /*#__PURE__*/React.createElement("div", {
        className: "modal fade captureViewerWindow",
        id: "CaptureModal",
        role: "dialog"
      }, /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__wrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__bg"
      }), /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__main"
      }, /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainWrapper"
      }, /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainHeader"
      }, /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainHeaderIcon"
      }, this.state.SelectedSessionHistoryItem && this.state.SelectedSessionHistoryItem.CaptureFileName.indexOf("WebSearch_") == 0 && /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Browser.svg"
      }), (!this.state.SelectedSessionHistoryItem || this.state.SelectedSessionHistoryItem.CaptureFileName.indexOf("WebSearch_") < 0) && /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Capture.svg"
      })), this.state.SelectedSessionHistoryItem && this.state.SelectedSessionHistoryItem.CaptureFileName.indexOf("WebSearch_") == 0 && [/*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainHeaderCont"
      }, intl.format(SessionHistories.Sharer, {
        name: this.state.SelectedSessionHistoryItem && this.state.SelectedSessionHistoryItem.UserName
      })), /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainHeaderCont"
      }, intl.format(SessionHistories.SharedDate, {
        date: this.state.SelectedSessionHistoryItem && Utility.ToMoment(this.state.SelectedSessionHistoryItem.RecordDateTime).format("YYYY/MM/DD HH:mm")
      }))], (!this.state.SelectedSessionHistoryItem || this.state.SelectedSessionHistoryItem.CaptureFileName.indexOf("WebSearch_") < 0) && [/*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainHeaderCont"
      }, intl.format(SessionHistories.Recorder, {
        name: this.state.SelectedSessionHistoryItem && this.state.SelectedSessionHistoryItem.UserName
      })), /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainHeaderCont"
      }, intl.format(SessionHistories.RecordingDate, {
        date: this.state.SelectedSessionHistoryItem && Utility.ToMoment(this.state.SelectedSessionHistoryItem.RecordDateTime).format("YYYY/MM/DD HH:mm")
      }))]), /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__mainImg"
      }, ((_this$state$SelectedS = this.state.SelectedSession) === null || _this$state$SelectedS === void 0 ? void 0 : _this$state$SelectedS.IsMyMeeting) && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn imgAndTextBtn imgAndTextBtn",
        onClick: this.onClickCaptureDelete.bind(this, this.state.SelectedSession, this.state.SelectedSessionHistoryIndex, this.state.SelectedSessionHistoryItem)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/delete_icon.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(SessionHistories.CaptureDelete))), ((_this$state$SelectedS2 = this.state.SelectedSession) === null || _this$state$SelectedS2 === void 0 ? void 0 : _this$state$SelectedS2.IsMyMeeting) && this.state.SelectedSessionHistoryItem != null && !this.state.SelectedSessionHistoryItem.UseSceneThumbnail && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn mainTools_sub_btn imgAndTextBtn imgAndTextBtn",
        onClick: this.onClickSetSceneThumbnail.bind(this, this.state.SelectedSession, this.state.SelectedSessionHistoryIndex, this.state.SelectedSessionHistoryItem)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_SceneSelect.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(SessionHistories.SetSceneThumbnail))), ((_this$state$SelectedS3 = this.state.SelectedSession) === null || _this$state$SelectedS3 === void 0 ? void 0 : _this$state$SelectedS3.IsMyMeeting) && this.state.SelectedSessionHistoryItem != null && this.state.SelectedSessionHistoryItem.UseSceneThumbnail && /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "mainTools__btn mainTools_sub_btn imgAndTextBtn imgAndTextBtn",
        onClick: this.onClickClearSceneThumbnail.bind(this, this.state.SelectedSession, this.state.SelectedSessionHistoryIndex, this.state.SelectedSessionHistoryItem)
      }, /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnImg mainTools__btnImg--mini"
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_SceneSelect.svg"
      })), /*#__PURE__*/React.createElement("div", {
        className: "imgAndTextBtn__btnText"
      }, intl.format(SessionHistories.ClearSceneThumbnail))), /*#__PURE__*/React.createElement("div", {
        id: "CaptureBack",
        className: "captureViewerWindow__arrowLeft",
        onClick: this.onClickCaptureBack.bind(this, this.state.SelectedSession, this.state.SelectedSessionHistoryIndex, this.state.SelectedSessionHistoryItem)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Arrow.svg"
      })), /*#__PURE__*/React.createElement("div", {
        id: "CaptureNext",
        className: "captureViewerWindow__arrowRight",
        onClick: this.onClickCaptureNext.bind(this, this.state.SelectedSession, this.state.SelectedSessionHistoryIndex, this.state.SelectedSessionHistoryItem)
      }, /*#__PURE__*/React.createElement("img", {
        src: "/assets/img/Icon_Arrow.svg"
      })), /*#__PURE__*/React.createElement("img", {
        id: "CaptureModelLoading",
        className: "loading-spinner",
        src: "/assets/img/Loading.svg"
      }), /*#__PURE__*/React.createElement("img", {
        id: "CaptureModalCapture",
        className: "loading-hidden",
        src: "/assets/img/noimage.png"
      })), /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__memoCont"
      }, /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__memoTitle"
      }, intl.format(SessionHistories.Memo)), /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__memoTextBox"
      }, (!this.state.SelectedSessionHistoryItem || this.state.SelectedSessionHistoryItem.MemoList.length == 0) && /*#__PURE__*/React.createElement("div", {
        className: "captureViewerWindow__memoTextCont--none"
      }, intl.format(SessionHistories.MemoNotFound)), this.state.SelectedSessionHistoryItem && this.state.SelectedSessionHistoryItem.MemoList.length > 0 && this.state.SelectedSessionHistoryItem.MemoList.map(function (x, _i) {
        return /*#__PURE__*/React.createElement("div", {
          className: "captureViewerWindow__memoTextCont"
        }, /*#__PURE__*/React.createElement("div", {
          className: "captureViewerWindow__memoState"
        }, /*#__PURE__*/React.createElement("div", {
          className: "captureViewerWindow__memoName"
        }, x.MemoUserName), /*#__PURE__*/React.createElement("div", {
          className: "captureViewerWindow__memoDate"
        }, Utility.ToMoment(x.MemoDateTime).format("YYYY/MM/DD HH:mm"))), /*#__PURE__*/React.createElement("div", {
          className: "captureViewerWindow__memoText"
        }, x.Memo != null ? x.Memo.split('\n').map(function (str, index) {
          return /*#__PURE__*/React.createElement(React.Fragment, {
            key: index
          }, str, /*#__PURE__*/React.createElement("br", null));
        }) : ""));
      }))), /*#__PURE__*/React.createElement("button", {
        type: "button",
        className: "modal-dialog modal-close",
        "data-dismiss": "modal",
        "aria-label": "Close",
        tabIndex: -1
      }, /*#__PURE__*/React.createElement("span", {
        "aria-hidden": "true"
      }, "\xD7"))))))))), this.state.EditMemModalMode != SessionHistoryEditMemoModalComponent.Mode.None && /*#__PURE__*/React.createElement(SessionHistoryEditMemoModalComponent["default"], {
        mode: this.state.EditMemModalMode,
        sessionIndex: this.state.EditSessionIndex ? this.state.EditSessionIndex : 0,
        materialIndex: this.state.EditMaterialIndex ? this.state.EditMaterialIndex : 0,
        memoIndex: this.state.EditMemoIndex ? this.state.EditMemoIndex : 0,
        memo: this.state.EditMemo ? this.state.EditMemo : "",
        onEdit: this.editMemoModal.bind(this),
        onHidden: this.hiddenEditMemoModal.bind(this)
      }));
    }
  }]);

  return MainComponent;
}(React.Component);
/**
 * レンダラー
 *
 * @param el バインド対象
 * @param common 共通
 * @param queryRefreshInterval 検索リフレッシュインターバル
 * @param sessionId 会議ID
 * @param userId ユーザーID
 */


export default function (el, common, queryRefreshInterval, sessionId, userId) {
  ReactDOM.render( /*#__PURE__*/React.createElement(MainComponent, {
    common: common,
    queryRefreshInterval: queryRefreshInterval,
    sessionId: sessionId,
    userId: userId
  }), el);
}